<template>
    <div class="np-group np-group-column align-items-start w-100" @dblclick="showModTask(this.task.id, this.status.id)" role="button">
        <div class="np-group w-100 justify-content-between">
            <div class="np-badge-s np-inactive np-font-xs">{{ this.status.title }}</div>
            <IndicatorDaysTo :dateStart="this.task.date_planned_start" :dateEnd="this.task.date_planned_end" v-if="!this.task.date_actual_end"/> 
            
        </div>
        <h3 class="np-font-m np-font-ellipsis np-pt-3 np-pb-3" :class="{'completed' : this.task.date_actual_end}">            
            {{ this.task.title }}
        </h3>
        <div class="np-group align-items-center w-100">
            <div class="np-badge-xs me-1" :class="this.task.priorityObj.class">
                {{ $t(this.task.priorityObj.label) }}
            </div>
            <IndicatorProgress :progress="task.percent_complete" size="np-badge-xs" />
            <div class="np-group flex-grow-1 justify-content-end np-ml-2">
                <CobaltProfilesList :users="this.task.performer" size="np-avatar-small" />
            </div>
        </div>
    </div>
    <!-- 
    <div class="np-font-ellipsis np-pb-2" :class="{'completed' : task.date_actual_end}">
        {{ this.task.description }}
    </div>
    --> 
</template>

<script>
import { localeDate, lightenDarkenColor, priorityValues } from '@/utils/format'
import CobaltProfilesList from "@/components/dashboard/parts/CobaltProfilesList.vue"
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 
import IndicatorProgress from './elements/IndicatorProgress.vue'
import { nameColor } from '@/utils/format'
import Config from '../config.js'

export default {
    components: {
        CobaltProfilesList,
        CobaltProfile,
        IndicatorDaysTo,
        IndicatorProgress
    },
    name: 'TaskCardEvent',
    props: {
        task: {
            type: Object,
            required: true
        },
        status: {
            type: Object,
            required: true
        }
    },
    computed: {
        deadlineColor: {
            get() {
                if (this.task.date_actual_end) {
                    return ''
                }
                const start = this.task.date_planned_start
                const end   = this.task.date_planned_end
                const section = ( end - start ) / 3
                const current =  new Date().getTime() / 1000

                if (current > end) {
                    return 'failed';
                }
                if (current < start + section) {
                    return 'level-0'
                }

                if (start > 0 && end > 0) {                    
                    if (start + section < current && current < end - section) {
                        return 'level-1'
                    }
                    if (end - section < current && current < end) {
                        return 'level-2'
                    }                                        
                }
                return ''
            }
        },        
        daysTo: {
            get() {
                const end   = this.task.date_planned_end
                const current =  new Date().getTime() / 1000

                if ( end > 0 && current < end) {   
                    return parseInt( ( end - current ) / 86400 )
                }
                return 0
            }
        }     
    },
    data() {
        return {
            Config,
            overlap: false,
            priorityValues
        }
    },
    methods: {
        localeDate,
        lightenDarkenColor,
        nameColor,
        showModTask(taskId, statusId) {
            this.$emit('showModTask', taskId, statusId);
        }       
    }
}
</script>